import type { LogoProps } from '@/components/header/components/logo/logo.types';
import { useWindowSize } from 'usehooks-ts';
import clsx from 'clsx';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { GeneralSlice } from '@/redux/general';
import { SliderSlice } from '@/redux/slider';
import Condition from '@/utils/condition';
import '@/components/header/components/logo/logo.css';

export default function Logo(props: LogoProps) {
  const logo = useAppSelector(GeneralSlice.selectors.logo);
  const selectedKeyword = useAppSelector(ConfigSlice.selectors.selectedKeyword);
  const currentQuestionId = useAppSelector(SliderSlice.selectors.currentId);
  const { width } = useWindowSize();

  const useRightmart = Condition.keyInQueryParamsOrCookiesEqual('rightmart', 'true') && logo.rightmart;
  const src = useRightmart ? logo.rightmart : width >= 768 ? logo.desktop : logo.mobile;
  const alt = useRightmart ? 'LFLogoRightmart' : width >= 768 ? 'LFLogoImage' : 'LFLogoImageMobile';

  const isInactive = currentQuestionId === 0;

  if (!src) return null;

  return (
    <button
      className={clsx('header-logo', { 'header-logo--inactive': isInactive })}
      type='button'
      aria-label='header-logo'
      aria-disabled={isInactive}
      onClick={() => props.onClick()}
    >
      <img
        title={selectedKeyword}
        className={clsx('header-logo__icon', { 'header-logo__icon--rightmart': useRightmart })}
        src={src}
        alt={alt}
      />
    </button>
  );
}
